import { gql } from "@apollo/client";

export const FR_MACHINE_TYPE_FIELDS = gql`
    fragment fr_MachineTypeFields on MachineType {
        MachineTypeId
        Name
    }
`;